/* eslint-disable func-names */
import { v4 as uuidv4 } from 'uuid';
import type { IAbTest } from '@/interface/IAbTest';

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = () => {};

export function isObject(val: any): boolean {
    return val !== null && typeof val === 'object';
}

export function keyLookup(obj: any, value: unknown): string {
    if (!isObject(obj)) throw Error('keyLookup obj is not an object');

    return Object.keys(obj).find(key => obj[key] === value) ?? '';
}

export function randomPick<T>(arr: T[]): T {
    return arr[~~(arr.length * Math.random())];
}

export function padLeft(str: string, length: number): string {
    if (str.length >= length) {
        return str;
    }
    return padLeft(`0${str}`, length);
}

export function setIntervalCallImmediately(cb: (...args: any[]) => void, timeout: number) {
    cb();
    return setInterval(cb, timeout);
}

export function getUserTGroup(abTestGroup: Record<number, IAbTest>) {
    if (!abTestGroup || Object.keys(abTestGroup).length === 0) {
        return '';
    }
    const groupNumber = Object.keys(abTestGroup)[0];
    const groupType = abTestGroup[Number(groupNumber)].isUseNewFeature ? 'B' : 'A';
    return groupNumber + groupType;
}

export function getUuid(digit = 8) {
    return uuidv4()
        .slice(0, digit)
        .replace(/-/g, '_');
}

export function hookBefore(target: any, methodName: string, hookFn: (...args: any[]) => void) {
    const original = target[methodName];
    target[methodName] = function (...args: any[]) {
        hookFn(...args);
        return original.apply(this, args);
    };
}

export function hookAfter(target: any, methodName: string, hookFn: (...args: any[]) => void) {
    const original = target[methodName];
    target[methodName] = function (...args: any[]) {
        const ret = original.apply(this, args);
        hookFn(...args);
        return ret;
    };
}

export function strReverse(str: string, toggle: boolean) {
    if (toggle) {
        let result = '';
        for (let index = str.length - 1; index >= 0; index--) {
            result += str[index];
        }
        return result;
    }
    return str;
}

/**
 * Creates an array being grouped to group of arrays which remains the same order.
 * Iteratee will receive each element and return a value indicate which group the element is.
 * @param collection
 * @param iteratee
 */
export function groupByWithOrder<T>(collection: T[], iteratee: (value: T) => string): T[][] {
    const len = collection.length;
    if (!Array.isArray(collection) || len === 0) return [];

    let prevKey = '';
    const result: T[][] = new Array(...[]);
    for (let i = 0; i < len; i++) {
        const element = collection[i];
        const currKey = iteratee(element);
        if (result.length === 0 || prevKey !== currKey) result.push([element]);
        else result[result.length - 1].push(element);
        prevKey = currKey;
    }
    return result;
}

export function sleep(second: number) {
    return new Promise<void>((resolve) => {
        setTimeout(() => {
            resolve();
        }, second * 1000);
    });
}
